import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      width: "80%"
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, {
    staticClass: "pa-2"
  }, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isSending
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Send mail")])]), _c("div", {
    staticClass: "pa-6"
  }, [_vm.isNeedingSync ? _c(VBtn, {
    staticClass: "sync-btn",
    attrs: {
      rounded: "",
      loading: _vm.isSyncing
    },
    on: {
      click: _vm.syncLatestVersion
    }
  }, [_c(VIcon, [_vm._v("mdi-lightning-bolt")]), _vm._v(" Click to sync latest version ")], 1) : _vm._e(), _c("MailTemplateForm", {
    attrs: {
      order: _vm.order,
      inboundDelivery: _vm.inboundDelivery,
      user: _vm.user,
      purchaseOrder: _vm.purchaseOrder,
      templates: _vm.emailTemplates,
      placeholders: _vm.emailPlaceholders,
      documents: _vm.documents,
      isDeletingTemplate: _vm.isDeletingTemplate,
      templateRequired: false,
      withRelatedFiles: ""
    },
    on: {
      edit: _vm.editTemplate,
      delete: _vm.deleteTemplate,
      change: _vm.changeTemplate,
      "click:new": _vm.newTemplate,
      "click:placeholder": _vm.clickPlaceholder,
      documentLoading: _vm.changeLoadingState
    },
    model: {
      value: _vm.form.emailTemplate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "emailTemplate", $$v);
      },
      expression: "form.emailTemplate"
    }
  })], 1), _c(VCardActions, {
    staticClass: "mb-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isSending
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isInvalidForm,
      loading: _vm.isSending
    },
    on: {
      click: function click($event) {
        return _vm.sendMail();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isMailTemplateFormLoading ? "Loading files" : "Send") + " ")])], 1)], 1)], 1), _vm.templateModalShown ? _c("MailTemplateModal", {
    attrs: {
      shown: _vm.templateModalShown,
      placeholders: _vm.emailPlaceholders,
      template: _vm.editableTemplate
    },
    on: {
      save: _vm.saveTemplate,
      close: _vm.closeTemplateModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };